var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{ref:"modalSuscripcion",attrs:{"centered":"","size":"md","hide-footer":"","hideHeaderClose":"","hideHeader":""},on:{"hidden":_vm.closemodalSuscripcion}},[_c('div',{staticClass:"d-block text-center"},[_c('create-suscripcion',{attrs:{"user-id":_vm.userId,"token-auth":_vm.tokenAuth,"id-local":_vm.idLocal}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }